<template>
  <div>
    <div v-if="!showBannerList.length" class="banner">
      <img
        v-if="mainBanner"
        :src="mainBanner"
        class="banner-img"
        alt="main-banner"
      />
    </div>
    <div
      class="banner banner-swiper-container swiper-container"
      v-show="showBannerList.length > 0"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in showBannerList"
          :key="index"
        >
          <img
            :src="item.bannerUrl"
            class="banner-img j-banner"
            :pointValue="item.redirectUrl"
            alt="banner-img"
            @click="jumpLink(item.redirectUrl)"
          />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Swiper from 'swiper';
import globalConfig from '@utiles/officialStore/globalConfig';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  data() {
    return {
      swiper: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      gameId: state => state.gameId,
      indexBannerList: state => state.activity.indexBannerList,
      picList: state => state.page.picList
    }),
    mainBanner() {
      return this.picList?.mainbanner;
    },
    showBannerList() {
      // 判断列表每个banner.basic?.bannerUrl不为空的情况，合成一个新数组
      const list = [];
      this.indexBannerList.forEach(item => {
        if (item?.basic?.bannerUrl) {
          list.push(item?.basic);
        }
      });
      return list;
    }
  },
  watch: {
    showBannerList: {
      deep: true,
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    }
  },
  methods: {
    jumpLink(link) {
      if (!link) return;
      sdkOpenLink({ link: getGlobalGetGotoLink({ link: link }) });
    },
    initSwiper() {
      try {
        const isMulti = this.showBannerList.length > 1;
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.banner-swiper-container', {
          loop: isMulti,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          pagination: isMulti
            ? {
                el: '.swiper-pagination',
                clickable: true
              }
            : false,
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.banner {
  display: block;
  width: 100%;
  height: 322px;
  margin-top: -20px;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-pagination {
  box-sizing: border-box;
  padding: 0 40px;
  text-align: right;
  bottom: 21px;
}
@media screen and (orientation: landscape) {
  .banner {
    height: 320px;
  }
}
</style>
<style lang="scss">
@import '@assets/scss/officialTopup/_dimen.scss';
.swiper-pagination-bullet {
  background: #fff;
  width: 12px;
  height: 12px;
  opacity: 1;
  margin: 0 5px;
}
.swiper-pagination-bullet-active {
  background: $themeColor;
}
</style>
